<template>
  <Card>
    <h1 slot="Title">Department Code</h1>
    <div slot="MainContent">
      <div class="ThreeWrapper">
        <ul>
          <li class="OneThird">
            <b>Fund Center Position</b>
          </li>
          <li class="OneThird">
            <b>Represents</b>
          </li>
        </ul>
        <br>
        <ul>
          <li class="OneThird">
            011
          </li>
          <li class="OneThird">
            Executive Office of the President
          </li>

          <li class="OneThird">
            016
          </li>
          <li class="OneThird">
            Department of Labor
          </li>

          <li class="OneThird">
            017
          </li>
          <li class="OneThird">
            Department of Navy
          </li>

          <li class="OneThird">
            021
          </li>
          <li class="OneThird">
            Department of Army
          </li>

          <li class="OneThird">
            054
          </li>
          <li class="OneThird">
            Federal Labor Relations  Authority
          </li>

          <li class="OneThird">
            057
          </li>
          <li class="OneThird">
            Department of the Air Force
          </li>    

          <li class="OneThird">
            084
          </li>
          <li class="OneThird">
            Armed Forces Retirement Home
          </li>        

          <li class="OneThird">
            097
          </li>
          <li class="OneThird">
            Office of the Secretary of Defense
          </li>    

          <li class="OneThird">
            099
          </li>
          <li class="OneThird">
            General Fund of the Treasury
          </li>    
        </ul>
        <br><br>
        <p>
          Go to DFAS- IN Manual 37-100-** PAR 21-DP for the entire list of Department Codes
        </p>
      </div>
      <a href="http://asafm.army.mil/offices/BU/Dfas37100.aspx?OfficeCode=1200" target="_blank">http://asafm.army.mil/offices/BU/Dfas37100.aspx?OfficeCode=1200</a>
    </div>
    <div slot="Notes">
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Department Code</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">Refer students to 37-100&gt;21-DPT and page 4 of the summary sheet</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">&nbsp;&nbsp;</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">&nbsp;(1)</span><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">&nbsp; &nbsp;Department Code (021)&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">The department code is not a part of the GFEBS line</span><span style="font-size: 16px; font-family: Calibri; vertical-align: baseline;">&nbsp;of accounting, but it is embedded in the Army financial system. Our services sister and other DoD organizations have their department codes embedded in their ERP systems as well.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); vertical-align: baseline;">The main point to remember here is that, you may have to do financial transactions for other DoD agencies, and you will have to use their department code in these transactions.</span></p>
    </div>
  </Card>
</template>

<style scoped>
.ThreeWrapper {
  width: 100%;
  max-width: 800px;
  margin-bottom: 32px;
}

ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 0;
}

ul > li {
  width: 50%;
  list-style: none;
  margin-bottom: 0;
}

ul > li:nth-child(4n), ul > li:nth-child(4n-1) {
  background-color: rgba(255, 255, 255, .2);
}

ul > li > b {
  font-weight: 700;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
    }
  }
  
}
</script>